import './brickandbasil/style';
import FormStructure from './brickandbasil/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js